<template>
  <div v-if="visible" class="dialog-backdrop" @click.self="closeDialog">
    <div class="dialog-card">
      <div v-if="videoUrl" class="video-container">
        <iframe
          v-if="youtubeId"
          :src="`https://www.youtube.com/embed/${youtubeId}?autoplay=1`"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen></iframe>
        <iframe v-else :src="videoUrl" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
      <div v-else>
        <img class="rounded-borders full-width" :src="imageUrl" style="aspect-ratio: 16 / 9; object-fit: cover; width: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaDialog',
  props: {
    media: Object,
    visible: Boolean,
  },
  emits: ['close'],
  computed: {
    videoUrl() {
      return this.media?.type !== 'image' ? this.media?.url : null
    },
    imageUrl() {
      return this.media?.type === 'image' ? this.media?.url : null
    },
    youtubeId() {
      return this.videoUrl?.includes('youtube.com') ? this.media?.key : null
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-card {
  background: white;
  border-radius: 24px;
  width: 700px;
  max-width: 90vw;
  max-height: 90vh;
  padding: 16px;
  overflow: auto;
  aspect-ratio: 16/9;
}
.video-container {
  width: 100%;
  aspect-ratio: 16/9;
  overflow: hidden;
}
.video-container iframe {
  margin: 0px;
  width: 100%;
  aspect-ratio: 16 / 9;
}
</style>
